





















































import { Vue, Component } from "vue-property-decorator";

import { SimpleInput as Simple } from "@netex/inputs";

import Preloader from "@/components/common/Preloader.vue";
import IconLogIn from "@/components/icons/IconLogIn.vue";

import requestLogin from "@/services/api/auth/login/";
import requestRestore from "@/services/api/auth/restore/";

import Title from "./Title.vue";
import { BaseModal } from "./BaseModal";

import { cartModule, personalModule } from "@/plugins/store-accessors";
import { AxiosError } from "axios";

interface ChildMethods {
  setError: (message?: string) => void;
  checkForErrors: () => string[] | undefined;
}

type DefaultRef = Vue | Element | Vue[] | Element[];
type ChildRef = (ChildMethods & DefaultRef) | undefined;

@Component({
  name: "login-modal",
  components: { BaseModal, Title, Preloader, IconLogIn, Simple },
})
export default class LoginModal extends Vue {
  phone = "";
  password = "";

  loading = false;
  passwordRestoreSent = false;

  get getMessage() {
    return personalModule.getMessage;
  }

  get phoneRef() {
    return this.$refs.phone as ChildRef;
  }

  get passwordRef() {
    return this.$refs.password as ChildRef;
  }

  async signIn(): Promise<void> {
    const phoneError = this.phoneRef?.checkForErrors();
    const passError = this.passwordRef?.checkForErrors();
    if (passError || phoneError) {
      return;
    }
    this.loading = true;
    try {
      const res = await requestLogin(this.phone, this.password);
      if (res.data.errors) {
        this.setErrors(res.data.errors);
      } else {
        cartModule.getCart();
        personalModule.login(res.data.data);
        // personalModule.setPhone(this.phone);
      }
    } catch (err) {
      const Error = err as AxiosError;
      this.setErrors(Error.response?.data.errors);
    }
    this.loading = false;
  }
  async passwordRestore(): Promise<void> {
    const phoneError = this.phoneRef?.checkForErrors();
    if (this.phone && !phoneError) {
      this.passwordRef?.setError("");
      this.loading = true;
      const res = await requestRestore(this.phone);
      this.loading = false;

      if (res.status >= 200 && res.status <= 400) {
        this.passwordRestoreSent = true;
      } else if (res.status >= 400 && res.data) {
        this.setErrors(res.data.errors);
      }
    }
  }
  setErrors(errors: { [key: string]: string[] }) {
    const errs = Object.keys(errors);
    errs.forEach(error => {
      switch (error) {
        case "phone":
          this.phoneRef?.setError(errors[error].join(" "));
          break;
        default:
          this.passwordRef?.setError(errors[error].join(" "));
          break;
      }
    });
  }
  setValue(str: string, val: string) {
    str === "phone" ? (this.phone = val) : (this.password = val);
  }
  closeModal() {
    if (this.getMessage) {
      this.$router.replace("/");
    }
    personalModule.hideLoginModal();
  }
}
